import { create } from "zustand";
import { persist } from "zustand/middleware";

// Estado de PRESENTACIÓN del Lanzador universal. `settingsGroupExpanded` recuerda
// si el grupo colapsable "Configuración" está expandido (persistido en
// localStorage). `editMode` es el modo de personalización IN SITU de la barra:
// efímero (NO persistido) para que un reload siempre vuelva a la barra normal.
type NavLauncherState = {
  settingsGroupExpanded: boolean;
  setSettingsGroupExpanded: (expanded: boolean) => void;
  editMode: boolean;
  setEditMode: (editMode: boolean) => void;
};

export const useNavLauncherStore = create<NavLauncherState>()(
  persist(
    (set) => ({
      settingsGroupExpanded: false,
      setSettingsGroupExpanded: (settingsGroupExpanded) => set({ settingsGroupExpanded }),

      editMode: false,
      setEditMode: (editMode) => set({ editMode }),
    }),
    {
      name: "nav-launcher-storage-v1",
      // Solo persistimos la preferencia del grupo Configuración; `editMode` es
      // transitorio y debe reiniciarse en cada carga.
      partialize: (state) => ({ settingsGroupExpanded: state.settingsGroupExpanded }),
    },
  ),
);
